import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotify } from 'hooks/useNotify'
import { getData, postData } from 'helpers/api'

export const useApi = () => {
  const { t } = useTranslation()
  const { notify } = useNotify()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const callApi = useCallback(
    async (
      method,
      url,
      payload = null,
      opts = {
        errorMessage: t('notification.failed_request'),
        successMessage: null,
        isWrapped: false,
      }
    ) => {
      setLoading(true)
      setError(null)

      try {
        const json =
          method === 'GET'
            ? await getData(url)
            : await postData(url, payload)

        if (json?.code === '0') {
          notify(json, json.message || opts?.successMessage)

          return opts.isWrapped
            ? { data: json, error: null }
            : { ...json, error: null }
        }

        notify(
          json,
          json?.error_message || opts?.errorMessage
        )

        return { data: null, error: json?.error_message }
      } catch (err) {
        setError(err)
        return { data: null, error: err.message }
      } finally {
        // setLoading(false)
        setTimeout(() => setLoading(false), 500)
      }
    },
    [t, notify]
  )

  return { request: callApi, loading, error }
}
